import CoreBase from '../../../services/engines/CoreBase';
import gatewayService from '../../../services/GatewayService';
import responseHelper from '../../../services/ResponseHelper';
import umlPkgLibCache from './UmlPkgLibCache';

const _name = 'UmlPkgLibFetcher';
const TOPIC = 'Jerny.UmlWorkspace'; // same topic as UmlNoteFetcher.js — same AANNAME (nog te verifiëren) applies here too
const PAGE_SIZE = 50;

class UmlPkgLibFetcher extends CoreBase {
    fetch = async () => {
        try {
            const umlType = 'UmlPkgLib';

            const resp = await gatewayService.getUserEntries(TOPIC, 1, PAGE_SIZE, umlType);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                this.logError('fetch', `code: ${resp?.status}`);
                return [];
            }

            let items = resp.data.items ?? [];
            items = items.filter((x) => x.stateId !== 999 && x.type === umlType);

            umlPkgLibCache.setCache(items);
            return items;
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const umlPkgLibFetcher = new UmlPkgLibFetcher();
export default umlPkgLibFetcher;
